(function () {
  var re = /Rs\.\s?([\d,]+)(?:\.00)?/g;
  function swap(t) { if (t.nodeValue.indexOf('Rs.') > -1) { var v = t.nodeValue.replace(re, '₹$1'); if (v !== t.nodeValue) t.nodeValue = v; } }
  function fix(root) {
    if (!root) return;
    if (root.nodeType === 3) { swap(root); return; }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(swap);
  }
  fix(document.body);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.type === 'characterData') swap(m.target);
      else m.addedNodes.forEach(fix);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
(function () {
  if (location.search.indexOf('bskdebug') < 0) return;
  window.addEventListener('load', function () {
    setTimeout(function () {
      var vw = document.documentElement.clientWidth, out = [];
      document.querySelectorAll('body *').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width > vw + 2 || r.right > vw + 2) {
          var deeper = false;
          for (var i = 0; i < el.children.length; i++) { var c = el.children[i].getBoundingClientRect(); if (c.width > vw + 2 || c.right > vw + 2) { deeper = true; break; } }
          if (!deeper) { out.push(el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') + (el.className && el.className.baseVal === undefined ? '.' + String(el.className).trim().split(/\s+/).join('.') : '') + '  w=' + Math.round(r.width) + ' right=' + Math.round(r.right)); el.style.outline = '3px solid red'; }
        }
      });
      var box = document.createElement('pre');
      box.style.cssText = 'position:fixed;left:8px;top:8px;z-index:99999;max-width:90vw;max-height:80vh;overflow:auto;background:#fff;color:#c00;border:2px solid #c00;padding:10px;font:12px/1.4 monospace;white-space:pre-wrap';
      var chain = [], el = document.querySelector('.product__info');
      while (el && el !== document.documentElement) { var cs = getComputedStyle(el); chain.push(el.tagName.toLowerCase() + (el.className && el.className.baseVal === undefined ? '.' + String(el.className).trim().split(/\s+/).slice(0, 2).join('.') : '') + ' w=' + Math.round(el.getBoundingClientRect().width) + ' ' + cs.display + ' ' + cs.position); el = el.parentElement; }
      var fixed = !![].slice.call(document.styleSheets).filter(function (x) { return x.href && x.href.indexOf('bsk-fix') > -1; }).length;
      box.textContent = 'viewport ' + vw + 'px, page ' + document.documentElement.scrollWidth + 'px, fix.css ' + (fixed ? 'loaded' : 'MISSING') + ', body overflow-x ' + getComputedStyle(document.body).overflowX + '\nCHAIN:\n' + chain.join('\n') + '\nWIDE:\n' + (out.slice(0, 12).join('\n') || 'nothing wider than the screen');
      document.body.appendChild(box);
    }, 1500);
  });
})();
